import React from 'react';
import CodeMirror from '@uiw/react-codemirror';
import PropTypes from 'prop-types';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Row, Col, Form, Select, Typography, Button } from 'antd';
import { mapInputs, mapOutputs } from '../../../utils';

const { Option } = Select;
const { Item } = Form;
const { Title } = Typography;

const CRUDCollectionSelection = ({
  sourceElements,
  collections,
  selectedCollection,
  setSelectedCollection,
  requestFilter,
  setRequestFilter,
  trigger,
  setTrigger,
  nextStep
}) => {
  const collectionTitles = Object.keys(collections);

  const tagDrag = (event, ElmLabel, field) => {
    // eslint-disable-next-line no-param-reassign
    event.dataTransfer.dropEffect = 'move';
    const data = `@{${ElmLabel}|${field}}`;
    event.dataTransfer.setData('text', data);
  };

  return (
    <>
      <Row>
        <Col span={12}>
          <Title level={5}>Sélectionner une collection</Title>
          <Item
            label="Action"
            name="action"
            rules={[{ required: true }]}
            initialValue={trigger}
          >
            <Select onChange={setTrigger} value={trigger}>
              <Option key="POST" value="POST">
                POST
              </Option>
              <Option key="DELETE" value="DELETE">
                DELETE
              </Option>
              <Option key="PATCH" value="PATCH">
                PATCH
              </Option>
              <Option key="GET" value="GET">
                GET
              </Option>
            </Select>
          </Item>

          <Item
            label="Collection"
            name="collection"
            rules={[{ required: true }]}
            initialValue={selectedCollection}
          >
            <Select
              showSearch
              value={selectedCollection}
              onChange={setSelectedCollection}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              {collectionTitles?.length > 0 &&
                collectionTitles.map((item) => (
                  <Option key={item} value={item}>
                    {item}
                  </Option>
                ))}
            </Select>
          </Item>
        </Col>

        <Col span={11} offset={1}>
          {collections !== '' &&
            mapOutputs({ ...collections[selectedCollection] })}
        </Col>
      </Row>

      <Row
        style={{ marginBottom: 16 }}
        hidden={trigger === 'POST' || trigger === ''}
      >
        <Row>Filtre de la requête :</Row>
        <Row style={{ margin: '8px 0' }}>
          {mapInputs(sourceElements, true, tagDrag)}
        </Row>
      </Row>
      <Item
        label="Filtre"
        name="requestFilter"
        rules={[{ required: true }]}
        initialValue={requestFilter}
      >
        <CodeMirror
          value={requestFilter}
          options={{
            mode: 'javascript',
            theme: 'material',
            lineNumbers: true
          }}
          onChange={(value) => setRequestFilter(value)}
        />
      </Item>
      <Row style={{ paddingTop: 16 }}>
        <Button type="primary" block onClick={nextStep}>
          Etape suivante
          <ArrowRightOutlined />
        </Button>
      </Row>
    </>
  );
};

CRUDCollectionSelection.propTypes = {
  sourceElements: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  collections: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
    .isRequired,
  selectedCollection: PropTypes.string.isRequired,
  setSelectedCollection: PropTypes.func.isRequired,
  trigger: PropTypes.string.isRequired,
  setTrigger: PropTypes.func.isRequired,
  requestFilter: PropTypes.string.isRequired,
  setRequestFilter: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired
};

export default CRUDCollectionSelection;
